import React, { useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Button } from "react-bootstrap";

function activationMessage(status) {
  // "success" / "failure" / "already active"
  if (status === "success") return "Your card is now active.";
  if (status === "failure")
    return "Unfortunately your card couldn't be activated.";
  return "Your card is already active.";
}

export default function DoActivate(props) {
  const [showOverlay, setShowOverlay] = useState(false);
  const [error, setError] = useState(false);
  // const [showActivate, setshowActivate] = useState(false);
  const [cardStatus, setCardStatus] = useState(null);

  function activate() {
    setShowOverlay(true);
    if (!window.OrendaGetResponse || window.isSiteBuilder) {
      setTimeout(() => {
        setCardStatus("success");
        setShowOverlay(false);
      }, 1000);
      return;
    }

    return window.OrendaGetResponse(
      { event_name: "activatePhysicalCard" },
      (response) => {
        if (response.error) return setError(true);
        // need a response to say is "active" or is "already active"
        // response.cardActivation.status = "success" / "failure" / "already active"
        setCardStatus(response.cardActivation.status);
        setShowOverlay(false);
        return;
      }
    );
  }

  if (error)
    return (
      <div className="orenda-frontend">
        <div className="loader message">
          <p>Unfortunately an error occured.</p>
        </div>
      </div>
    );

  if (showOverlay)
    return (
      <div className="orenda-frontend">
        <div className="loader spinner">
          <ClipLoader size={20} /><span className="message">Please wait...</span>
        </div>
      </div>
    );

  if (cardStatus)
    return (
      <div className="orenda-frontend">
        <div className="status-message">{activationMessage(cardStatus)}</div>
      </div>
    );

  return (
    <div className="orenda-frontend">
      <Button
        className="getactivate"
        variant="outline-dark"
        onClick={() => activate()}
      >
        Activate Now
      </Button>
    </div>
  );
}
